import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as MicroUtils from '../../utils';
import { env } from '@ivy/fts/envInfo/envInfo';
import { translateUrl } from '@/api/goods/statistics';
let Nav = class Nav extends Vue {
    dataChange(newData) {
        console.log(newData);
    }
    get getSrc() {
        return imgUrl => {
            return imgUrl ? imgUrl : require('../../images/pic-place.png');
        };
    }
    get getClass() {
        let noText = this.data.navs.every(nav => !nav.desc);
        return `${this.data.lineRule} ${noText ? 'no-text' : ''}`;
    }
    get navStyle() {
        return {
            background: this.data.bgColor,
        };
    }
    get imgStyle() {
        return {
            'object-fit': this.data.filling || 'cover',
        };
    }
    get fontStyle() {
        return {
            color: this.data.fontColor || '#555555',
        };
    }
    created() { }
    async goLink(item, index) {
        let url = item.jumpUrl;
        if (!url)
            return;
        let translateRes = await translateUrl(url);
        // 微页面组件内容点击埋点
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: this.data.title,
            ContentName: item.desc || `宫格${index + 1}`,
            JumpType: translateRes.jumpType,
            JumpContentName: translateRes.jumpName,
            JumpContentID: translateRes.jumpId,
            isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
            ['p3', 'isTabPage'],
            ['p4', 'JumpType_JumpContentID_JumpContentName'],
        ]);
        url && MicroUtils.goLink(url, env);
    }
};
tslib_1.__decorate([
    Prop()
], Nav.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], Nav.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Watch('data.compMargin')
], Nav.prototype, "dataChange", null);
Nav = tslib_1.__decorate([
    Component({})
], Nav);
export default Nav;
